<!--TODO: Make left nav float-->
<template xmlns="http://www.w3.org/1999/html">
  <b-container fluid="sm">
    <b-row class="text-left">
      <b-col class="text-left" cols="2">
        <div class="sidebar">
          <b-card>
            <b-nav toggleable="sm" vertical id="navbar">
              <b-nav-item @click="goto('intro')">Introduction</b-nav-item>
              <b-nav-item @click="goto('genes')">Genes</b-nav-item>
              <b-nav-item @click="goto('mutations')">Mutations</b-nav-item>
              <b-nav-item @click="goto('compounds')">Compounds</b-nav-item>
            </b-nav>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div ref="intro">
        <h2>Here's to Wine, Chocolate and a Long Healthy Life</h2>

        <blockquote><p align="justify">In animals like mice, flies and roundworms, scientists have discovered a remarkable impact of genes on the ageing process. Could these help us live longer, healthier lives?</p>

          <em>Keywords:</em> aging, biogerontology, geroscience, gerontology</blockquote>

        <hr width="80%" size="1">

        <p align="justify">Jeanne Calment, who died in 1997 at the age of 122, remains the oldest person on record (Allard et al., 1998). One might assume that she led a faultless, healthy lifestyle. Not at all. Every year on her birthday, as her celebrity grew, journalists flocked to her house in the south of France to ask her for the secret to a long life. One year she reportedly replied that it was because she stopped smoking when she turned 100. </p>

        <p align="justify">In addition to smoking for most of her life, Madame Calment was also fond of Port wine and chocolate (<a href="http://www.nytimes.com/1997/08/05/world/jeanne-calment-world-s-elder-dies-at-122.html">more than two pounds</a> of chocolate a week). She's's not the only one. Studies have failed to find healthy lifestyle choices to be the common factor between centenarians. As Nir Barzilai, who studies healthy Jewish centenarians, <a href="http://www.nytimes.com/2004/02/24/health/a-conversation-with-nir-barzilai-it-s-not-the-yogurt-looking-for-longevity-genes.html">put it</a>: It's not the yogurt. </p>

        <p align="justify">Instead, scientists have discovered that longevity is prevalent in certain families and the focus is now on discovering the genes, or the DNA instructions, that favour a long, healthy life.</p>
        </div>
        <div ref="genes">
          <h2>Genes</h2>
        <p align="justify">In animals like mice, flies and roundworms, scientists have discovered a remarkable impact of genes on the ageing process. Hundreds of tiny instructions in the genome have been found to regulate longevity. In nematode worms, a mutation on the daf-2 gene <a href="http://genomics.senescence.info/genes/details.php?gene=daf-2&organism=elegans">can lead to a doubled</a>, but still healthy lifespan. In tiny roundworms, the current record is a subtle change in the age-1 gene that extends lifespan ten-fold (Ayyadevara et al., 2008). If this could be applied to humans, it would mean people living more than 1,000 years.</p>

        <p align="justify">Life-extension effects from genetic engineering, however, tend to be more modest in mammals, though there is still evidence of health benefits. In mice, mutating the <a href="http://genomics.senescence.info/genes/entry.php?hgnc=GHR">growth hormone receptor gene</a>, which is crucial for regulating growth and cell proliferation, results in dwarf animals that not only <a href="http://www.senescence.info//programmed-ageing#The_Endocrine_System_as_the_Pacemaker_of_Aging">live 40% longer</a> than normal but are protected from age-related diseases, like cancer, and exhibit a later onset of degenerative changes. In this example, it's like the whole mammalian ageing process is retarded by changing a single gene.</p>

        <p align="justify">Will longevity genes found in model organisms such as worms and mice be relevant to humans? We already know about human gene mutations that can modulate ageing in humans. So-called progeroid syndromes resemble accelerated ageing, and fascinating yet devastating diseases like Werner syndrome lead to patients who look and feel much older than their actual age and have an average lifespan of 47. Both result from subtle genetic mutations. </p>
        </div>
        <div ref="mutations">
          <h2>Mutations</h2>
        <p align="justify">Studies have also focused on individuals with mutations in genes that have been associated with life-extension in rodents. People with a rare condition called Laron syndrome, who have a deficiency in the growth hormone receptor, are small and appear to be strongly protected from cancer (Guevara-Aguirre et al., 2011), which shows that genes regulating longevity in model organisms may at least lead to therapies against human age-related diseases.</p>

        <p align="justify">We also know that the <a href="/ageing-animals">longevity of species is plastic</a> and that genetic changes over long evolutionary periods of time can result in major increases in longevity. Some species like mice age very quickly, even under the best conditions in captivity, while others live longer than humans. Bowhead whales, for example, have been estimated to live to more than 200-years-old and some species of fish and turtles don't even appear to grow old. Ageing is neither universal nor inevitable. Scientists are trying to learn the secrets of these species in hope it will allow us to devise ways of living longer.</p>

        <p align="justify">By 2050 the proportion of people aged over 60 in Britain will rise from 21% to almost 40%, making the improvement of life and health of older people imperative. There is not much we can do now to live longer, except follow motherly advice like not smoking, exercising regularly and having a healthy diet rich in fruits and vegetables. Vitamins and antioxidants have long been touted as capable of retarding ageing, but their only proven outcome is a very expensive urine. Still, it's a progress from the first half of the 20th century when Serge Voronoff in France grafted tissues from monkey testicles into wealthy patients claiming this would rejuvenate them. </p>
        </div>
        <div ref="compounds">
        <h2>Compounds</h2>
        <p align="justify">More recently, compounds have been found to extend lifespan in mice. The most famous of these is <a href="http://www.senescence.info//caloric-restriction#Potential_CR_Mimetics_and_Resveratrol">resveratrol</a>, found in red wine. It only appears to extend lifespan in obese mice rather than normal ones, however. And if you're thinking of compensating the lack of exercise with more red wine, the human dosage would be more than 100 bottles of red wine per day.</p>

        <p align="justify">Woody Allen quipped that: You can live to be a hundred if you give up all the things that make you want to live to be a hundred. Calment and other centenarians demonstrate that this is, in fact, not true. They also show that it is possible to live a long life with good health and remain mentally intact. We cannot choose our genes, but perhaps we can identify nutrients or even drugs that could provide the benefits of longevity genes to the many people who don't have them. Ultimately, the goal is to allow people to live longer, healthier lives while enjoying everyday pleasures like Port wine and chocolate. And I'll certainly drink to that.</p>

        <hr width="60%" size="1">

        <blockquote><p align="justify"><strong>Notice:</strong> This article is an adapted and updated version from the original published in <a href="https://theconversation.com/heres-to-wine-chocolate-and-a-long-healthy-life-31587">The Conversation</a>; it was also republished by <a href="https://www.independent.co.uk/life-style/health-and-families/features/heres-to-wine-chocolate-and-a-long-healthy-life-9734250.html">The Independent</a>.</p></blockquote>
        </div>
      </b-col>
    </b-row>
  </b-container>


</template>


<!--<script type="text/javascript">-->

<!--  export default {-->
<!--    name: 'Login',-->
<!--    data () {-->
<!--      return {-->
<!--        user: {-->
<!--          email: '',-->
<!--          password: ''-->
<!--        }-->
<!--      }-->
<!--    },-->
<!--    methods: {-->
<!--      login: function () {-->
<!--        if (!this.user.email || !this.user.password) {-->
<!--          return 0-->
<!--        }-->
<!--  -->
<!--      }-->
<!--    },-->
<!--      goto: function(refName) {-->
<!--        var element = this.$refs[refName];-->
<!--        var top = element.offsetTop;-->

<!--      window.scrollTo(0, top);-->
<!--    }-->
<!--  }-->
<!--</script>-->
<script>
import Footer from "./AppFooter";
export default {
  components: {Footer},
  methods: {
    goto(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    }
  }
};

// window.onscroll = function() {myFunction()};
//
// var navbar = document.getElementById("navbar");
// var sticky = navbar.offsetTop;
//
// function myFunction() {
//   if (window.pageYOffset >= sticky) {
//     navbar.classList.add("sticky")
//   } else {
//     navbar.classList.remove("sticky");
//   }
// }
</script>
<style>
h2 {
  padding-top: 30px;
}
.sidebar {
  position: -webkit-sticky;
  position: sticky;
  top: 3%;
}

</style>



// WEBPACK FOOTER //
// src/components/WineChocolate.vue